import { ThemeOptions, createTheme } from "@mui/material";
import { palette } from "./palette";
import { fontFamily, typography } from "./typography";
import { useComponentsTheme } from "./components";
import { skSK as coreSkSK } from '@mui/material/locale';
import { skSK } from '@mui/x-date-pickers/locales';

declare module '@mui/material/styles' {
    interface VigTheme {
        variables?: {
            drawerWidth: number;
            appBarHeight: number;
            spacing: number;
            primaryButtonFocusBorderColor?: string;
        };
    }

    interface Theme extends VigTheme { }

    interface ThemeOptions extends VigTheme { }
}

export const themeOptions: ThemeOptions = {
    spacing: 8,
    shape: {
        borderRadius: 8,
    },
    palette,
    typography,
    components: {
        MuiCssBaseline: {
            styleOverrides: fontFamily,
        },
    },
    variables: {
        drawerWidth: 268,
        appBarHeight: 64,
        spacing: 8,
    }
};

let theme = createTheme(themeOptions, skSK, coreSkSK);
theme = useComponentsTheme(theme);

export const kooperativaTheme = theme;
export const komunalnaTheme = createTheme(theme, {
    palette: {
        primary: {
            main: '#005baa',
            light: '#2673c4',
            dark: '#00376b',
            contrastText: '#FFFFFF',
        },
    },
});